const DisclosuresScreen = () => {
  
    return (
       <p>Disclosures Screen here</p>
    )
}

export default DisclosuresScreen